import type { AuthUseCaseError } from "~application/auth/errors/auth-errors.ts";

const loginToastErrors: Record<AuthUseCaseError["kind"], { title: string; details: string }> = {
  InvalidCredentials: {
    title: "Identifiants incorrects",
    details: "L’adresse e-mail ou le mot de passe est incorrect. Vérifiez vos informations et réessayez.",
  },
  TransportError: {
    title: "Une erreur est survenue",
    details:
      "Un problème inattendu est survenu. Veuillez réessayer dans quelques instants. Si le problème persiste, vérifiez votre connexion internet.",
  },
  UnexpectedError: {
    title: "Erreur du serveur",
    details: "Le serveur a renvoyé une réponse invalide. Réessayez plus tard.",
  },
  NotAuthenticated: {
    title: "Erreur du serveur",
    details: "Le serveur a renvoyé une réponse invalide. Réessayez plus tard.",
  },
  ForbiddenByPolicy: {
    title: "Non autorisé",
    details: "Vous n'avez pas les droits nécéssaires pour accéder à l'application",
  },
};

export const AUTHENTICATION_FRENCH_LOCALE = {
  connectToVoltexploit: "Connectez vous à votre compte",
  username: "Nom d'utilisateur",
  password: "Mot de passe",
  loginBtn: "Se connecter",
  placeholders: {
    username: "john.doe{'@'}voltalis.com",
    password: "Mot de passe",
  },
  errors: {
    toasts: {
      login: loginToastErrors,
    },
  },
};
